import * as React from 'react'
import { cn } from '@/lib/utils'
import './loader.css'

interface LoaderProps extends React.HTMLAttributes<HTMLDivElement> {
  text?: string
}

export function Loader({
  className,
  text = 'Loading...',
  ...props
}: LoaderProps) {
  return (
    <div data-testid="loader" {...props}>
      <div className={cn('sk-circle', className)}>
        {[...Array(12)].map((_, i) => (
          <div key={i} className={cn('sk-child', `sk-circle${i + 1}`)} />
        ))}
      </div>
      {text && (
        <p className="text-center mt-4 text-sm text-foreground">{text}</p>
      )}
    </div>
  )
}
